module.exports = __webpack_public_path__ + "img/logo_smart_ofa.2bba0245.svg";